/* HZ 2026-09-14: moved out of snippets/hz-complete-the-look.liquid into this deferred asset file.
   Same code; it used to be inlined into every page (and, for the quick-add,
   once per product card) and blocked HTML parsing while it evaluated. */
(function() {
  'use strict';

  /* ═══ HELPERS ═══ */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }
  function updateCartBubble() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      document.querySelectorAll('.cart-count-bubble span').forEach(function(b) { b.textContent = c.item_count; });
      /* Also try to open the HZ cart drawer if available */
      if (window.hzCartDrawerOpen) window.hzCartDrawerOpen();
    });
  }

  /* ═══ FEATURED SET PIECE — inline size pills + ATC ═══ */
  var featAtc = document.getElementById('hzCtlFeatAtc');
  var featPrice = document.getElementById('hzCtlFeatPrice');
  var announce = document.getElementById('hzCtlAnnounce');

  if (featAtc) {
    /* Size pill selection */
    document.querySelectorAll('.hz-ctl__pill').forEach(function(pill) {
      pill.addEventListener('click', function() {
        if (pill.disabled) return;
        /* Update active state */
        document.querySelectorAll('.hz-ctl__pill').forEach(function(p) {
          p.classList.remove('hz-ctl__pill--active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('hz-ctl__pill--active');
        pill.setAttribute('aria-checked', 'true');

        /* Update price */
        var price = parseInt(pill.dataset.price, 10);
        var compare = parseInt(pill.dataset.compare, 10);
        if (compare && compare > price) {
          featPrice.innerHTML = '<span class="hz-ctl__feat-compare">' + money(compare) + '</span><span class="hz-ctl__feat-current">' + money(price) + '</span>';
        } else {
          featPrice.innerHTML = '<span class="hz-ctl__feat-current">' + money(price) + '</span>';
        }

        /* Update ATC button */
        featAtc.dataset.variantId = pill.dataset.variantId;
        featAtc.disabled = false;
        featAtc.textContent = (featAtc.dataset.preorder === 'true' ? 'Pre-Order' : 'Add to Cart') + ' \u2014 ' + money(price);
        featAtc.classList.remove('hz-ctl__feat-atc--added');
      });
    });

    /* ATC click */
    featAtc.addEventListener('click', function() {
      if (featAtc.disabled) return;
      var vid = parseInt(featAtc.dataset.variantId, 10);
      featAtc.textContent = 'Adding\u2026';
      featAtc.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('fail');
        return r.json();
      })
      .then(function() {
        featAtc.textContent = 'Added to Cart \u2713';
        featAtc.classList.add('hz-ctl__feat-atc--added');
        if (announce) announce.textContent = 'Item added to cart.';
        updateCartBubble();
        setTimeout(function() {
          featAtc.disabled = false;
          var active = document.querySelector('.hz-ctl__pill--active');
          if (active) {
            featAtc.textContent = (featAtc.dataset.preorder === 'true' ? 'Pre-Order' : 'Add to Cart') + ' \u2014 ' + money(parseInt(active.dataset.price, 10));
          }
          featAtc.classList.remove('hz-ctl__feat-atc--added');
        }, 3000);
      })
      .catch(function() {
        featAtc.textContent = 'Error \u2014 Try Again';
        featAtc.disabled = false;
        setTimeout(function() {
          var active = document.querySelector('.hz-ctl__pill--active');
          if (active) {
            featAtc.textContent = (featAtc.dataset.preorder === 'true' ? 'Pre-Order' : 'Add to Cart') + ' \u2014 ' + money(parseInt(active.dataset.price, 10));
          }
        }, 2000);
      });
    });
  }

  /* ═══ INLINE COLOR DOTS — switch variant + image on CTL cards ═══ */
  document.querySelectorAll('.hz-ctl__color-dot').forEach(function(dot) {
    dot.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = this.dataset.ctlColorVid;
      var pid = this.dataset.ctlColorPid;
      var imgSrc = this.dataset.ctlColorImg;

      /* Update active dot */
      this.parentElement.querySelectorAll('.hz-ctl__color-dot').forEach(function(d) {
        d.style.borderColor = 'transparent';
        d.classList.remove('hz-ctl__color-dot--active');
      });
      this.style.borderColor = '#0a0a0a';
      this.classList.add('hz-ctl__color-dot--active');

      /* Update the add button's variant ID */
      var card = this.closest('.hz-ctl__card');
      if (card) {
        var addBtn = card.querySelector('[data-ctl-direct-add]');
        if (addBtn) addBtn.dataset.variantId = vid;

        /* Swap card image */
        if (imgSrc) {
          var img = card.querySelector('.hz-ctl__card-img');
          if (img) img.src = imgSrc;
        }
      }
    });
  });

  /* Direct add to cart for inline color products */
  document.querySelectorAll('[data-ctl-direct-add]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = parseInt(this.dataset.variantId, 10);
      if (!vid) return;
      var origText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Added ✓';
        btn.style.background = '#16a34a';
        btn.style.borderColor = '#16a34a';
        btn.style.color = '#fff';
        setTimeout(function() {
          btn.textContent = origText;
          btn.disabled = false;
          btn.style.background = '';
          btn.style.borderColor = '';
          btn.style.color = '';
        }, 2000);
        /* Refresh cart count */
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var countEls = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
          countEls.forEach(function(el) { el.textContent = cart.item_count; });
        });
      })
      .catch(function() {
        btn.textContent = 'Error';
        setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2000);
      });
    });
  });

  /* ═══ SECONDARY CARDS — single-variant direct ATC or quick view modal ═══ */
  var modal = document.getElementById('hzCtlQv');
  if (!modal) return;

  var panel = modal.querySelector('.hz-ctl-qv__panel');
  var overlay = modal.querySelector('.hz-ctl-qv__overlay');
  var closeBtn = modal.querySelector('.hz-ctl-qv__close');
  var qvImg = modal.querySelector('.hz-ctl-qv__img');
  var qvTitle = modal.querySelector('.hz-ctl-qv__title');
  var qvPrice = modal.querySelector('.hz-ctl-qv__price');
  var qvOptions = modal.querySelector('.hz-ctl-qv__options');
  var qvAtc = modal.querySelector('.hz-ctl-qv__atc');
  var qvLink = modal.querySelector('.hz-ctl-qv__link');
  var qvAnnounce = modal.querySelector('.hz-ctl-qv__announce');
  var qvVariantId = null;

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    modal.inert = true;
    document.body.style.overflow = '';
  }
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (modal.getAttribute('aria-hidden') === 'false' && e.key === 'Escape') closeModal();
  });

  function openQuickView(handle, btn) {
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var src = product.featured_image || (product.images && product.images[0]) || '';
        qvImg.src = src ? src.replace(/(\.[a-z]+)(\?.*)?$/i, '_500x$1$2') : '';
        qvImg.alt = product.title;
        qvTitle.textContent = product.title;
        qvLink.href = '/products/' + encodeURIComponent(handle);
        qvOptions.innerHTML = '';

        if (product.variants.length === 1) {
          qvVariantId = product.variants[0].id;
          qvPrice.textContent = money(product.variants[0].price);
          qvAtc.disabled = !product.variants[0].available;
          qvAtc.textContent = product.variants[0].available ? (product.variants[0].inventory_policy === 'continue' && product.variants[0].inventory_quantity <= 0 ? 'Pre-Order' : 'Add to Cart') : 'Sold Out';
        } else {
          /* Build variant pills — color dots for Color option, text pills for Size */
          var optName = product.options[0] || 'Size';
          var isColorOption = optName.toLowerCase() === 'color' || optName.toLowerCase() === 'colour';
          var colorMap = {
            'gold': '#C8A96E', 'silver': '#C0C0C0', 'black': '#0a0a0a',
            'baby blue': '#89CFF0', 'butter yellow': '#FAE29C', 'lavender': '#B4A7D6',
            'red': '#E41E20', 'white': '#fff', 'olive': '#556B2F',
            'camel': '#C19A6B', 'rust': '#B7410E', 'sand': '#C2B280'
          };

          var label = document.createElement('label');
          label.textContent = optName + (isColorOption ? ': ' : '');
          var colorLabel = null;
          if (isColorOption) {
            colorLabel = document.createElement('span');
            colorLabel.style.fontWeight = '400';
            label.appendChild(colorLabel);
          }
          var pillWrap = document.createElement('div');
          pillWrap.className = 'hz-ctl-qv__pills';
          if (isColorOption) pillWrap.style.gap = '8px';

          qvVariantId = null;
          product.variants.forEach(function(v, i) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.disabled = !v.available;

            if (isColorOption) {
              /* Render as color dot */
              pill.className = 'hz-ctl-qv__color-dot';
              var bg = colorMap[v.options[0].toLowerCase()] || '#ccc';
              pill.style.cssText = 'width:24px;height:24px;border-radius:50%;border:2px solid transparent;padding:0;cursor:pointer;box-shadow:0 0 0 1px rgba(0,0,0,0.1);background:' + bg + ';transition:border-color 0.15s;';
              pill.title = v.options[0];
              pill.setAttribute('aria-label', v.options[0]);
            } else {
              pill.className = 'hz-ctl-qv__pill';
              pill.textContent = v.options[0];
            }

            if (v.available && qvVariantId === null) {
              qvVariantId = v.id;
              if (isColorOption) {
                pill.style.borderColor = '#0a0a0a';
                if (colorLabel) colorLabel.textContent = v.options[0];
              } else {
                pill.classList.add('hz-ctl-qv__pill--active');
              }
              qvPrice.textContent = money(v.price);
              qvAtc.disabled = false;
              qvAtc.textContent = 'Add to Cart';
            }
            pill.addEventListener('click', function() {
              if (isColorOption) {
                pillWrap.querySelectorAll('.hz-ctl-qv__color-dot').forEach(function(p) { p.style.borderColor = 'transparent'; });
                pill.style.borderColor = '#0a0a0a';
                if (colorLabel) colorLabel.textContent = v.options[0];
                /* Swap modal image to variant image */
                if (v.featured_image) {
                  qvImg.src = v.featured_image.src.replace(/\.(jpg|png|webp)/, '_600x.$1');
                }
              } else {
                pillWrap.querySelectorAll('.hz-ctl-qv__pill').forEach(function(p) { p.classList.remove('hz-ctl-qv__pill--active'); });
                pill.classList.add('hz-ctl-qv__pill--active');
              }
              qvVariantId = v.id;
              qvPrice.textContent = money(v.price);
              qvAtc.disabled = !v.available;
              qvAtc.textContent = v.available ? (v.inventory_policy === 'continue' && v.inventory_quantity <= 0 ? 'Pre-Order' : 'Add to Cart') : 'Sold Out';
            });
            pillWrap.appendChild(pill);
          });

          qvOptions.appendChild(label);
          qvOptions.appendChild(pillWrap);

          if (!qvVariantId) {
            qvAtc.disabled = true;
            qvAtc.textContent = 'Sold Out';
            qvPrice.textContent = money(product.variants[0].price);
          }
        }

        modal.setAttribute('aria-hidden', 'false');
        modal.inert = false;
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      })
      .catch(function() {
        window.location.href = '/products/' + encodeURIComponent(handle);
      });
  }

  /* QV ATC */
  qvAtc.addEventListener('click', function() {
    if (!qvVariantId || qvAtc.disabled) return;
    qvAtc.textContent = 'Adding\u2026';
    qvAtc.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: qvVariantId, quantity: 1 }] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('fail');
      return r.json();
    })
    .then(function() {
      qvAtc.textContent = 'Added \u2713';
      qvAtc.style.background = '#34c759';
      if (qvAnnounce) qvAnnounce.textContent = 'Item added to cart.';
      updateCartBubble();
      setTimeout(closeModal, 1200);
      setTimeout(function() {
        qvAtc.style.background = '';
        qvAtc.textContent = 'Add to Cart';
        qvAtc.disabled = false;
      }, 1500);
    })
    .catch(function() {
      qvAtc.textContent = 'Error — Try Again';
      qvAtc.disabled = false;
      qvAtc.style.background = '#ff3b30';
      setTimeout(function() { qvAtc.style.background = ''; qvAtc.textContent = 'Add to Cart'; }, 2000);
    });
  });

  /* Bind secondary card buttons */
  document.querySelectorAll('.hz-ctl__card-btn:not([data-ctl-direct-add])').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var handle = btn.dataset.handle;
      var card = btn.closest('.hz-ctl__card');

      /* Single-variant: direct ATC */
      if (btn.textContent.trim() === 'Add to Cart' || btn.textContent.trim() === 'Pre-Order') {
        var origText = btn.textContent.trim();
        btn.textContent = 'Adding\u2026';
        btn.disabled = true;

        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            if (product.variants.length === 1) {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: product.variants[0].id, quantity: 1 }] })
              }).then(function(r) {
                if (!r.ok) throw new Error('fail');
                btn.textContent = 'Added \u2713';
                btn.classList.add('hz-ctl__card-btn--added');
                updateCartBubble();
                setTimeout(function() {
                  btn.textContent = origText;
                  btn.classList.remove('hz-ctl__card-btn--added');
                  btn.disabled = false;
                }, 2500);
              });
            } else {
              /* Multi-variant — ATC with first available */
              var firstAvail = product.variants.find(function(v) { return v.available; });
              if (firstAvail) {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [{ id: firstAvail.id, quantity: 1 }] })
                }).then(function(r) {
                  if (!r.ok) throw new Error('fail');
                  btn.textContent = 'Added \u2713';
                  btn.classList.add('hz-ctl__card-btn--added');
                  updateCartBubble();
                  setTimeout(function() {
                    btn.textContent = origText;
                    btn.classList.remove('hz-ctl__card-btn--added');
                    btn.disabled = false;
                  }, 2500);
                });
              } else {
                btn.textContent = origText;
                btn.disabled = false;
              }
            }
          })
          .catch(function() {
            btn.textContent = origText;
            btn.disabled = false;
          });
      } else {
        /* Multi-variant: open quick view */
        openQuickView(handle, btn);
      }
    });
  });

  /* ═══ COMPLETE THE SET — condense "Colour / Size" pills into two rows ═══
     The server renders one pill per variant. After the velour colourway merge that
     is 3 colours x 7 sizes = 21 buttons under a single "Size" label, which is the
     mess on both breakpoints.

     This reads those pills, splits each label on " / ", and rebuilds them as a
     Colour row and a Size row. Pure progressive enhancement: it runs off the DOM
     the server already produced, so there is no Liquid branch to evaluate
     inconsistently, it adapts to whatever product is featured, and if it does not
     run the original pills are left exactly as they are. */
  (function hzCtlCondenseOptions() {
    var SIZE_LADDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];

    var wrap = document.querySelector('.hz-ctl__feat-sizes');
    var pillBox = wrap && wrap.querySelector('.hz-ctl__feat-pills');
    var featAtc = document.getElementById('hzCtlFeatAtc');
    var featPrice = document.getElementById('hzCtlFeatPrice');
    if (!wrap || !pillBox || !featAtc) return;

    var pills = Array.prototype.slice.call(pillBox.querySelectorAll('.hz-ctl__pill'));
    if (pills.length < 2) return;

    /* Only act on two-option products: every label must read "Colour / Size". */
    var rows = [];
    for (var i = 0; i < pills.length; i++) {
      var parts = (pills[i].textContent || '').trim().split(' / ');
      if (parts.length !== 2) return;
      rows.push({
        color: parts[0],
        size: parts[1],
        id: pills[i].dataset.variantId,
        price: parseInt(pills[i].dataset.price, 10),
        compare: parseInt(pills[i].dataset.compare, 10) || 0,
        available: pills[i].dataset.available === 'true',
        active: pills[i].classList.contains('hz-ctl__pill--active')
      });
    }

    /* Injected inside the snippet's IIFE, so the theme's own money() is in scope
       and formats to the shop's currency. The fallback only applies if that ever
       stops being true. */
    var fmt = (typeof money === 'function') ? money : function (cents) {
      return '$' + (cents / 100).toFixed(2);
    };

    var map = {};
    var colors = [];
    var sizes = [];
    rows.forEach(function (r) {
      map[r.color + ' ' + r.size] = r;
      if (colors.indexOf(r.color) === -1) colors.push(r.color);
      if (sizes.indexOf(r.size) === -1) sizes.push(r.size);
    });
    sizes.sort(function (a, b) {
      var ia = SIZE_LADDER.indexOf(a), ib = SIZE_LADDER.indexOf(b);
      if (ia === -1 && ib === -1) return 0;
      if (ia === -1) return 1;          /* unknown sizes fall to the end, never dropped */
      if (ib === -1) return -1;
      return ia - ib;
    });

    var initial = rows.filter(function (r) { return r.active; })[0] ||
                  rows.filter(function (r) { return r.available; })[0] || rows[0];
    var sel = { color: initial.color, size: initial.size };

    function buildRow(label, values, group, display) {
      var row = document.createElement('div');
      row.className = 'hz-ctl__feat-optrow';
      row.dataset.hzRow = group;      /* lets CSS grid the two rows differently */
      row.setAttribute('role', 'radiogroup');
      row.setAttribute('aria-label', 'Select ' + label);
      var lab = document.createElement('span');
      lab.className = 'hz-ctl__feat-size-label';
      lab.textContent = label;
      row.appendChild(lab);
      var box = document.createElement('div');
      box.className = 'hz-ctl__feat-pills';
      values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hz-ctl__pill';
        b.dataset.hzGroup = group;
        b.dataset.hzValue = val;                  /* full value drives lookups */
        b.setAttribute('role', 'radio');
        b.textContent = (display && display[val]) || val;
        if (display && display[val] && display[val] !== val) b.title = val;
        box.appendChild(b);
      });
      row.appendChild(box);
      return row;
    }

    /* The set-piece column is ~170px on desktop, so "White Stitch / Red Stitch
       / Black Stitch" cannot sit side by side. When every colour ends in the same
       word, drop it from the button text. */
    var colorLabels = null;
    var tails = colors.map(function (c) { return c.split(' ').slice(-1)[0]; });
    var wordCounts = colors.map(function (c) { return c.split(' ').length; });
    if (colors.length > 1 &&
        tails.every(function (t) { return t === tails[0]; }) &&
        wordCounts.every(function (n) { return n > 1; })) {
      colorLabels = {};
      colors.forEach(function (c) {
        colorLabels[c] = c.split(' ').slice(0, -1).join(' ');
      });
    }

    var colorRow = buildRow('Color', colors, 'color', colorLabels);
    var sizeRow = buildRow('Size', sizes, 'size');

    wrap.setAttribute('data-hz-ctl-condensed', 'true');
    wrap.removeAttribute('role');
    wrap.removeAttribute('aria-label');
    pillBox.parentNode.removeChild(pillBox);
    var oldLabel = wrap.querySelector('.hz-ctl__feat-size-label');
    if (oldLabel) oldLabel.parentNode.removeChild(oldLabel);
    wrap.appendChild(colorRow);
    wrap.appendChild(sizeRow);

    function apply() {
      /* size availability depends on the chosen colour */
      sizeRow.querySelectorAll('[data-hz-group="size"]').forEach(function (b) {
        var cand = map[sel.color + ' ' + b.dataset.hzValue];
        var ok = !!(cand && cand.available);
        b.classList.toggle('hz-ctl__pill--oos', !ok);
        b.disabled = !ok;
      });
      [[colorRow, 'color'], [sizeRow, 'size']].forEach(function (pair) {
        pair[0].querySelectorAll('[data-hz-group]').forEach(function (b) {
          var on = b.dataset.hzValue === sel[pair[1]];
          b.classList.toggle('hz-ctl__pill--active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });

      var v = map[sel.color + ' ' + sel.size];
      if (!v) {
        featAtc.disabled = true;
        featAtc.textContent = 'Select options';
        return;
      }
      if (featPrice) {
        /* Values are integers parsed from data-price/data-compare, formatted by
           money() — no user-supplied content. Mirrors the existing pill handler. */
        featPrice.innerHTML = (v.compare && v.compare > v.price)
          ? '<span class="hz-ctl__feat-compare">' + fmt(v.compare) +
            '</span><span class="hz-ctl__feat-current">' + fmt(v.price) + '</span>'
          : '<span class="hz-ctl__feat-current">' + fmt(v.price) + '</span>';
      }
      featAtc.dataset.variantId = v.id;
      featAtc.disabled = !v.available;
      featAtc.classList.remove('hz-ctl__feat-atc--added');
      featAtc.textContent = v.available
        ? ((featAtc.dataset.preorder === 'true' ? 'Pre-Order' : 'Add to Cart') +
           ' — ' + fmt(v.price))
        : 'Sold Out';
    }

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-hz-group]') : null;
      if (!btn || btn.disabled) return;
      sel[btn.dataset.hzGroup] = btn.dataset.hzValue;
      /* keep the pair valid: if this colour lacks the chosen size, take its first */
      if (!map[sel.color + ' ' + sel.size] ||
          !map[sel.color + ' ' + sel.size].available) {
        for (var i = 0; i < sizes.length; i++) {
          var cand = map[sel.color + ' ' + sizes[i]];
          if (cand && cand.available) { sel.size = sizes[i]; break; }
        }
      }
      apply();
    });

    apply();
  })();
})();
